import { http, HttpResponse } from 'msw'

export const mockDeactivateCustomerCustomField = http.put(
  '/my-business/api/agency/v1/customers/custom-fields/:customFieldAlphaId/deactivate',
  () => {
    return HttpResponse.json(
      { timestamp: new Date().toISOString() },
      { status: 200 },
    )
  },
)
